import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { NavGroup, NavHeader, NavItem } from "./Sidebar";
import Auth from "../../shared/Auth";
import * as fa from '@fortawesome/free-solid-svg-icons';

class NavMenu extends BaseCom {

    async componentDidMount() {
        await this.fillListAsync('/api/spec/list', 'specList');
        try {
            this.setState({ user: await this.getLoginAsync() });
        }
        catch {}
        await this.ensureENV();
    }

    render() {
        return (
            <>
                <NavHeader label="Main" />
                <NavGroup>
                    <NavItem href="dashboard" label="Dashboard" icon={fa.faGaugeSimpleHigh} />
                    <NavItem href="health" label="System Health" icon={fa.faHeart} />
                    <NavItem href="api-credential" label="API Credentials" icon={fa.faKey} />
                    <NavItem href="webhook" label="Webhooks" icon={fa.faTruck} end />
                    <NavItem href="webhook/log" label="Webhook Log" icon={fa.faListAlt} />
                </NavGroup>

                <NavHeader label="Develop" />
                <NavGroup>
                    {this.state.specList?.map((i,idx) => <NavItem key={idx} href={`spec/${i.ident}`} label={i.name} icon={fa.faGear} />)}
                </NavGroup>

                <NavHeader label="Data Sandbox" />
                <NavGroup>
                    <NavItem href="lab/order" label="Lab Orders" icon={fa.faVial} />
                </NavGroup>

                {this.state.ENV?.hasInternal && this.state.user?.isInternal && <>
                    <NavHeader label="Internal" />
                    <NavGroup>
                        <NavItem href="internal/analyzer" label="Analyzers" icon={fa.faFlaskVial} />
                    </NavGroup>
                </>}


                {(Auth.hasPolicy('admin')) && <>
                    <NavHeader label="Admin" />
                    <NavGroup>
                        <NavItem href="admin" label={'Administration'} icon={fa.faScrewdriverWrench} />
                    </NavGroup>
                </>}
            </>
        );
    }
}

export default withParamsAndNavigate(NavMenu);